import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import NachweisIcon from '#components/svg/icons/NavAusbildungsnachweise'
import StyledText from '#components/a/StyledText'
import {routeKeys} from '#config/routeKeys'

export default class MissedAusbildungsnachweisBenachrichtigung extends React.PureComponent {
  onClickNotification = () => {
    const {onNotificationClick} = this.props
    onNotificationClick(routeKeys.ausbildungsnachweise)
  }

  render() {
    const text = i18n.t('notification_text_missed_ausbildungsnachweis')

    return (
      <button type="button" className="notification" onClick={this.onClickNotification}>
        <div className="notification__icon">
          <NachweisIcon />
        </div>
        <StyledText text={text} modifier="notification" />
      </button>
    )
  }
}

MissedAusbildungsnachweisBenachrichtigung.propTypes = {
  onNotificationClick: PropTypes.func.isRequired,
}
